import { useQueryClient, useMutation } from '@tanstack/react-query';

import { Query, Model } from './api';

export const useJobMutation = (accountId) => {
  const queryClient = useQueryClient();
  const basePath = `accounts/${accountId}/jobs`;

  return useMutation({
    mutationFn: async (jobData) => {
      const instance = new Model('job', jobData);

      const options = {
        httpMethod: 'post',
      };

      if (instance.id) {
        options.httpMethod = 'patch';
      }

      return await new Query(basePath, null, options)
        .setData(instance.toAPI(), instance.id)
        .run();
    },
    onSuccess: (instance) => {
      queryClient.invalidateQueries([accountId, 'jobs']);
      queryClient.setQueryData([accountId, 'jobs', instance.id], instance);
      if (instance.name) {
        queryClient.setQueryData([accountId, 'jobs', instance.name], instance);
      }
    },
  });
};
